export default "__VITE_ASSET__D1YWT6hW__"